import { LegalLayout, LegalSection, PH } from "../components/LegalLayout";

export default function CGU() {
  return (
    <LegalLayout title="Conditions Générales d'Utilisation et de Vente (CGU/CGV)" path="/cgu" testid="page-cgu">
      <LegalSection n="1" title="Objet">
        <p>Les présentes conditions régissent l'utilisation du service StreatEat, annuaire en ligne de foodtrucks (le « Service »), édité par <PH>NOM DE LA SOCIÉTÉ</PH>, ainsi que la souscription aux offres payantes destinées aux gérants de foodtrucks.</p>
      </LegalSection>

      <LegalSection n="2" title="Définitions">
        <ul className="list-disc pl-5 space-y-1">
          <li><b>Gourmand</b> : utilisateur consultant l'annuaire.</li>
          <li><b>Gérant</b> : professionnel référençant son foodtruck.</li>
          <li><b>Offres</b> : Essentiel (gratuite), Pro et Pro+ (payantes).</li>
        </ul>
      </LegalSection>

      <LegalSection n="3" title="Inscription et compte">
        <p>La création d'un compte requiert une adresse e-mail valide et un mot de passe. L'utilisateur s'engage à fournir des informations exactes et à préserver la confidentialité de ses identifiants. Il est responsable des activités effectuées depuis son compte.</p>
      </LegalSection>

      <LegalSection n="4" title="Offres et tarifs">
        <p>Les offres et tarifs sont présentés sur la page Tarifs. Les prix sont indiqués en euros <PH>TTC / HT</PH>. L'éditeur se réserve le droit de modifier ses tarifs ; les modifications n'affectent pas les abonnements en cours.</p>
        <p>Des tarifs de lancement à durée/quantité limitée peuvent être proposés selon les conditions affichées.</p>
      </LegalSection>

      <LegalSection n="5" title="Modalités de paiement">
        <p>Les paiements sont traités de manière sécurisée par notre prestataire <b>Stripe</b>. Les abonnements sont facturés de façon récurrente (mensuelle) jusqu'à résiliation. Aucune donnée de carte bancaire n'est stockée sur nos serveurs.</p>
      </LegalSection>

      <LegalSection n="6" title="Durée, renouvellement et résiliation">
        <p>Les abonnements sont conclus pour une durée d'un mois, renouvelable par tacite reconduction. Le gérant peut résilier à tout moment depuis son espace « Mon compte » (portail de facturation) ; la résiliation prend effet à la fin de la période en cours, sans remboursement au prorata sauf disposition légale contraire.</p>
      </LegalSection>

      <LegalSection n="7" title="Droit de rétractation">
        <p>Conformément à l'article L221-28 du Code de la consommation, le professionnel reconnaît que le Service, à destination des besoins de son activité professionnelle, <PH>relève / ne relève pas</PH> du droit de rétractation. Précisez ici votre politique : <PH>À COMPLÉTER</PH>.</p>
      </LegalSection>

      <LegalSection n="8" title="Obligations des utilisateurs">
        <p>L'utilisateur s'engage à ne pas publier de contenu illicite, trompeur ou portant atteinte aux droits de tiers. Les gérants garantissent l'exactitude des informations publiées (emplacements, horaires, photos). L'éditeur peut suspendre ou supprimer tout contenu ou compte contrevenant.</p>
      </LegalSection>

      <LegalSection n="9" title="Responsabilité">
        <p>StreatEat est un service de mise en relation et d'annuaire. L'éditeur ne saurait être tenu responsable des informations publiées par les gérants ni des transactions réalisées entre gourmands et foodtrucks. Le Service est fourni « en l'état », sans garantie de disponibilité ininterrompue.</p>
      </LegalSection>

      <LegalSection n="10" title="Données personnelles">
        <p>Le traitement des données est décrit dans notre <a href="/confidentialite" className="text-street-gold font-semibold hover:underline">Politique de confidentialité</a>.</p>
      </LegalSection>

      <LegalSection n="11" title="Droit applicable et litiges">
        <p>Les présentes conditions sont soumises au droit français. En cas de litige, et à défaut de résolution amiable, compétence est attribuée aux tribunaux de <PH>VILLE</PH>. Conformément à la réglementation, l'utilisateur consommateur peut recourir à un médiateur de la consommation : <PH>NOM ET COORDONNÉES DU MÉDIATEUR</PH>.</p>
      </LegalSection>
    </LegalLayout>
  );
}
